import { useMutation, useQueryClient } from '@tanstack/react-query';
import { SpecialOfferService } from 'modules/sales-offer/special-offer/services';
import { SPECIAL_OFFERS_LIST_KEY } from 'modules/sales-offer/special-offer/constants';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';

export const useDeleteSpecialOffer = (id: string, onClose: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation('specialOffer');
  return useMutation(() => SpecialOfferService.delete(id), {
    onSuccess: (data) => {
      toast.success(t('successDeleted'));
      onClose?.();
      queryClient.invalidateQueries({ queryKey: [SPECIAL_OFFERS_LIST_KEY] });
      queryClient.invalidateQueries({ queryKey: [id] });
    },
  });
};
